import {useState,useEffect} from "react";
import { useNavigate } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import PasswordStrengthBar from 'react-password-strength-bar';

import {TenantFrontendApi_GetTenantLicenceListWithInUse,TenantFrontendApi_PostTenantLicence,TenantFrontendApi_DeleteTenantLicence,TenantFrontendApi_DeleteUserLicence,TenantFrontendApi_GetResellerLicenceList,TenantFrontendApi_GetTenant, TenantFrontendApi_GetUser,TenantFrontendApi_UpdateUser,TenantFrontendApi_DeleteUser, TenantFrontendApi_ChangeUserPassword,TenantFrontendApi_ChangeUserLicense} from "./TenantFrontendApi";
import { Translate } from "./Translator"
import Header from "./Header"
import MainMenu from "./MainMenu";
import Footer from "./Footer"
import BlueBar from "./BlueBar";

import HomeLogo from "./Assets/HomeLogo.png"
import CloseLogo from "./Assets/CloseLogo.jpg"

import './Tenant.css';
import './EditUser.css';

function EditUser(){

    const navigate = useNavigate();
    const [mRepaint,SetRepaint]=useState(false)
    const [mUser,SetUser]=useState()
    const [mUserGuid,SetUserGuid]=useState()
    const [mUpdateResult,SetUpdateResult] = useState("")
    const [mUpdateSuccessfully,SetUpdateSuccessfully] = useState(false)
    const [mUserPassword,SetUserPassword] = useState("")
    const [mConfirmPassword,SetConfirmPassword] = useState("")
    const [mChangePasswordResult,SetChangePasswordResult] = useState("")
    const [mChangePasswordSuccessfully,SetChangePasswordSuccessfully] = useState(false)
    const [mPasswordVisible, SetPasswordVisible] = useState(false)
    const [mLicenceList,SetLicenceList] = useState([])
    const [mLicenceGuid,SetLicenceGuid] = useState("")
    const [mExpireLicence,SetExpireLicence] = useState("")
    
    const [mTenantGuid,SetTenantGuid]=useState()
    const [mTenant, SetTenant] = useState("")

    const [mExpireCurrentLicence,SetExpireCurrentLicense] = useState(true)

    const [mAssignNewLicenceError,SetAssignNewLicenceError] = useState("")
    const [mShowPopUpErrorBuyingLicenses,SetShowPopUpErrorBuyingLicenses] = useState("")
    const [mGeneralPopup,SetGeneralPopUp] = useState("")
    const isSuperTenant = sessionStorage.getItem("IsSuperTenant") === "1" ? true : false
    const [isLastTenantAdminUser, setIsLastTenantAdminUser] = useState(false)
    const [isResellerOwnUser,SetIsResellerOwnUser] = useState(false)
    
    useEffect(() => {
        
        window.scrollTo(0, 0);

        async function GetUser(aUserGuid) {
            try {
                const UserResponse = await TenantFrontendApi_GetUser(sessionStorage.getItem("token"), aUserGuid);
                SetUser(UserResponse.data);
                SetLicenceGuid(UserResponse.data.LicenceGuid);
                console.log(UserResponse.data.TenantGuid);
                SetTenantGuid(UserResponse.data.TenantGuid); // This will trigger the next useEffect
            } catch (ex) {
                let error = ex;
                let errorCode = null;
                try {
                    if (ex.response && ex.response.status) {
                        errorCode = ex.response.status;
                        console.log(errorCode);
                    }
                    navigate('../error?errorcode=' + errorCode + '&error=user');
                    error = ex.response.data.Exception;
                } catch {}
                console.log("Error: " + error);
            }
        }
    
        //Get the parameters from the URL
        const windowUrl = window.location.search;
        const params = new URLSearchParams(windowUrl);
        const ciParams = new URLSearchParams();
        for (const [name, value] of params) {
            ciParams.append(name.toLowerCase(), value);
        }
        const userguid = ciParams.get('userguid');
        SetUserGuid(userguid);
        GetUser(userguid);

        if(isSuperTenant)
        {
            SetIsResellerOwnUser(userguid === sessionStorage.getItem("UserGuid"))
            setIsLastTenantAdminUser(sessionStorage.getItem("LastUserWithTenantAdminRole") === userguid)
        }
        
    
    }, [navigate,isSuperTenant]); // First useEffect to get the user
    
    useEffect(() => {
        async function GetTenant() {
            try {
                console.log("Getting tenant");
                const TenantResponse = await TenantFrontendApi_GetTenant(sessionStorage.getItem("token"), mTenantGuid);
                SetTenant(TenantResponse.data);
            } catch (ex) {
                let error = ex;
                let errorCode = null;
                try {
                    if (ex.response && ex.response.status) {
                        errorCode = ex.response.status;
                        console.log(errorCode);
                    }
                    navigate('../error?errorcode=' + errorCode + '&error=tenant');
                    error = ex.response.data.Exception;
                } catch {}
                console.log("Error: " + error);
            }
        }

        async function GetLicenceList(aTenantGuid) {
            if(sessionStorage.getItem("IsSuperTenant") === "1" && sessionStorage.getItem("ManageLicenses") === "0")
            {
                try
                { 
                    const LicenceListResponse = await TenantFrontendApi_GetTenantLicenceListWithInUse(sessionStorage.getItem("token"),aTenantGuid)
                    // Filter only licenses that have available units
                    const availableLicenses = LicenceListResponse.data.filter(license =>
                        (license.Count - license.InUse) > 0
                    );

                    // Set only the usable licenses to state
                    console.log(availableLicenses)
                    SetLicenceList(availableLicenses);                        
                }

                catch (ex)
                {
                    var error = ex;
                    try { error = ex.response.data.Exception; } catch {}  
                }

            }
            else
            {
                try
                { 
                    
                    const LicenceListResponse = await TenantFrontendApi_GetResellerLicenceList(sessionStorage.getItem("token"))
                    SetLicenceList(LicenceListResponse.data)  
                }

                catch (ex)
                {
                    error = ex;
                    try { error = ex.response.data.Exception; } catch {}  
                    console.log("Error: " + error);
                }     
            }
        }
    
        if (mTenantGuid)
        { // Ensure mTenantGuid has been set before calling these functions
            GetTenant();
        }
        GetLicenceList(mTenantGuid);

    }, [mTenantGuid, navigate]); // Second useEffect depends on mTenantGuid
    
    const SetName = (aName) => {
        if(mUser)
        {
            mUser.Name = aName
            SetRepaint(!mRepaint)
        }
    }

    const SetEmail = (aEmail) => {
        if(mUser)
        {
            mUser.Email = aEmail
            SetRepaint(!mRepaint)
        }

    }

    const SetUserApiSetting = (aUserApiSetting) => {

        const updatedApiSetting = aUserApiSetting.replace(/\n/g, '\r\n');
        SetUser((prevUser) => ({
            ...prevUser,
            ApiSettings: updatedApiSetting
        }));
        SetRepaint(!mRepaint);
        
    }

    const SetIsRecognitionAdmin = (aIsRecognitionAdmin) =>{
        mUser.IsRecognitionAdmin = aIsRecognitionAdmin
        SetRepaint(!mRepaint)
    }

    const SetIsTenantAdmin = (aIsTenantAdmin) =>
    {
        if(isSuperTenant && isResellerOwnUser)
        {
            SetGeneralPopUp("You cannot modify the privileges of your own login account. Please contact your provider for assistance!")
        }
        else if (isSuperTenant && isLastTenantAdminUser)
        {
            SetGeneralPopUp("You cannot modify the privileges of your last user with a user accoutnt admin privilages!")
        }
        else
        {
            mUser.IsTenantAdmin = aIsTenantAdmin
            SetRepaint(!mRepaint)
        }
    }

    const SetSaveUserSettingsResultShow = (aMessage) =>{
        //
    }

    const SetPressSaveUserSettings = (aFlag) =>{
        //
    }

    async function UpdateUser() {

        try
        {
            //console.log("Updating user")
            console.log("ISTenantAdmin:" + mUser.IsTenantAdmin)
            const UpdateUserResponse = await TenantFrontendApi_UpdateUser(sessionStorage.getItem("token"),mUser.UserGuid,mUser.Email,mUser.Name,mUser.ApiSettings,mUser.IsRecognitionAdmin,mUser.IsTenantAdmin,mUser.TenantGuid,mLicenceGuid)
            console.log(JSON.stringify(UpdateUserResponse))
            SetSaveUserSettingsResultShow("The user updated successfully")
            SetUpdateResult("The user updated successfully")
            SetUpdateSuccessfully(true)
            if(mTenantGuid)
            {
                navigate('../tenant?tenantguid=' + mTenantGuid)
            }
            else
            {
                navigate('../user?userguid=' + mUserGuid + '&tenantguid=' + mTenantGuid)
            }
        }

        catch (ex)
        {
            var error = ex;
            try { error = ex.response.data.Exception; } catch {}  
            console.log("Error: " + error);
            SetSaveUserSettingsResultShow("The user is not updated !")
            SetUpdateResult("You are not allow to assign this license to current user")
            SetUpdateSuccessfully(false)
        }
    }

    async function DeleteUser(aUserGuid) {
        try
        {
            //console.log("Deleting user")
            const DeleteUserResponse = await TenantFrontendApi_DeleteUser(sessionStorage.getItem("token"),aUserGuid)
            console.log(DeleteUserResponse)
            if(mTenantGuid)
            {
                navigate('../tenant?tenantguid=' + mTenantGuid)
            }
            else
            {
                navigate('../users')
            }
        }
        catch (ex)
        {
            var error = ex;
            try { error = ex.response.data.Exception;
                console.log(ex.response.data)
             } catch {}  
            console.log("Error: " + error);
        }
    }

    async function ChangeUserPassword(){
        try
        {
            //console.log("Changing user password")
            const ChangeUserPasswordResponse = await TenantFrontendApi_ChangeUserPassword(sessionStorage.getItem("token"),mUserGuid,mUserPassword,mUser.TenantGuid)
            console.log(JSON.stringify(ChangeUserPasswordResponse))
            SetChangePasswordResult("The user password is updated successfully")
            SetChangePasswordSuccessfully(true)
        }

        catch (ex)
        {
            var error = ex;
            try { error = ex.response.data.Exception; } catch {}  
            console.log("Error: " + error);
            SetChangePasswordResult("The user password is not updated correctlly")
            SetChangePasswordSuccessfully(false)
        }
    }

    function handleSaveUserSettings(){
        SetPressSaveUserSettings(true)
        return(
            UpdateUser()
        )
       
    }

    function handleChangePassword(){

        if(mUserPassword && mConfirmPassword)

        {
            if(mUserPassword === mConfirmPassword)
            {
                return(ChangeUserPassword())
            }

            else
            {
                //the passwords are not same 
                SetChangePasswordSuccessfully(false)
                SetChangePasswordResult("The passwords are not same")

            }  
        }
        else
        {
            SetChangePasswordSuccessfully(false)
            SetChangePasswordResult("Both fields should be fill it")  
            
        }
    }

    function handleDeleteUser()
    {
        return(DeleteUser())  
    }
        

    function languageChanged(){
        SetRepaint(!mRepaint)
    }

    function ExpireLicence()
    {
        DeleteUserLicence()
    }

    async function DeleteUserLicence()
    {
        try{
            await TenantFrontendApi_DeleteUserLicence(sessionStorage.getItem("token"),mUserGuid,mUser.TenantGuid)
            console.log("Seccessfully deleting user license.")
            return;
        }
        catch(ex)
        {
            var error = ex;
            try { error = ex.response.data.Exception; } catch {}  
            console.log("Error: " + error);
        }
    }

    async function BuyNeededLicenseForTenant()
    {
        try
        {   
            await TenantFrontendApi_PostTenantLicence(
                sessionStorage.getItem("token"),
                mTenantGuid,
                mLicenceGuid,
                1
            );
            return;
        }
        catch (ex)
        {
            let errorTenantLicenceResponse = "Unknown error";

            // Try to extract the most meaningful message
            try {
                if (ex.response?.data?.Exception) {
                    errorTenantLicenceResponse = ex.response.data.Exception;
                } else if (ex.response?.data?.message) {
                    errorTenantLicenceResponse = ex.response.data.message;
                } else if (ex.message) {
                    errorTenantLicenceResponse = ex.message;
                } else {
                    errorTenantLicenceResponse = JSON.stringify(ex);
                }
            } catch (innerEx) {
                console.warn("Error parsing exception", innerEx);
            }

            console.error("Tenant Licence API Error:", errorTenantLicenceResponse);
            console.debug("Full exception object:", ex);
        }
    }
        
    async function AssignNewLicense()
    {          
        if(mLicenceGuid === "None")
        {
            await DeleteUserLicence();

            if(mExpireCurrentLicence)
            {
                await DeleteTenantLicence();
            }

            SetGeneralPopUp("User license updated successfully.")
            SetRepaint(!mRepaint)

        }
        else
        {
            try
            {
                console.log("IsTenantAdmin: " + mUser.IsTenantAdmin )
                await TenantFrontendApi_ChangeUserLicense(sessionStorage.getItem("token"),mUserGuid,mUser.TenantGuid,mLicenceGuid)
                if(mExpireCurrentLicence)
                {
                    await DeleteTenantLicence();
                }
                SetGeneralPopUp("User license updated successfully.")
                SetRepaint(!mRepaint)
            }
            catch(ex)
            {
                var error = ex;
                try
                { 
                    error = ex.response.data.Exception;
                    console.log(ex.response.data)
                    SetAssignNewLicenceError(ex.response.data)
                }
                catch {}  
                console.log("Error: " + error);
            } 
        }
    }

    async function DeleteTenantLicence()
    {
        try
        {
            console.log("Deleting Licence in tenant")
            const DeleteLicecnceResponse = await TenantFrontendApi_DeleteTenantLicence(sessionStorage.getItem("token"),mUser.TenantGuid,mUser.LicenceGuid,1)
            console.log(DeleteLicecnceResponse.data)
            console.log("Delete licences also in tenant")
            return;
        }

        catch(ex){
            console.log(ex.response.data)
            var error = ex;
            try { error = ex.response.data.Exception; } catch {}  
            console.log("Error: " + error);
        }
    }

    const ChangeExpireCurrentLicenseVariable = (aKeepCurrentLicense) =>{
        SetExpireCurrentLicense(!aKeepCurrentLicense);
        SetRepaint(!mRepaint);
    }

    async function BuyLicenseButtonHandler()
    {
        if(sessionStorage.getItem("IsSuperTenant") === "1" && sessionStorage.getItem("ManageLicenses") === "0")
        {
            SetShowPopUpErrorBuyingLicenses("You do not have the privilege to manage licenses. Please contact your provider to access.")
        }
        else
        {
            SetAssignNewLicenceError("");

            // Wait for BuyNeededLicenseForTenant to complete
            await BuyNeededLicenseForTenant();
            
            // Then continue with AssignNewLicense
            AssignNewLicense();
        }
    }
    
    let PageLocation = <span />;

    if (mTenantGuid)
    {
        PageLocation = (
            <tr height="60">
                <td width="40" align="left">
                    <span width="20" align="left">
                        <img
                            alt="Home logo"
                            className="HomeLogo pointer"
                            src={HomeLogo}
                            onClick={() => navigate("/")}
                        />
                    </span>
                    <span width="20" className="blue" align="center">
                        {" "} / {" "}
                    </span>
                    <a
                        href={"../tenant?tenantguid=" + mTenantGuid}
                        className="underline pointer bold black"
                        style={{ textAlign: "center" }}  // Correct way to apply text-align in React
                    >
                        {Translate("Tenants")}
                    </a>

                    <span width="20" className="blue" align="center">
                        {" "} / {" "}
                    </span>
                    <a
                        href={"../tenant?tenantguid=" + mTenantGuid}
                        className="underline pointer bold black"
                        width="20"
                        align="left"
                    >
                        {mTenant.Company}
                    </a>
                    <span width="20" className="blue" align="center">
                        {" "} / {" "}
                    </span>
                    <a
                        href={"../tenantusers?tenantguid=" + mTenantGuid}
                        className="underline pointer bold black"
                        width="40"
                        align="left"
                        textAlign="button"
                    >
                        {Translate("Users")}
                    </a>
                    <span width="20" className="blue" align="center">
                        {" "} / {" "}
                    </span>
                    <a
                        href={"../user?userguid=" + mUserGuid + "&tenantguid=" + mTenantGuid}
                        width="50"
                        align="left"
                        className="bold underline pointer black"
                    >
                        {mUser ? mUser.Name : ""}
                    </a>
                    <span width="20" className="blue" align="center">
                        {" "} / {" "}
                    </span>
                    <span className="bold">{Translate("Edit")}</span>
                </td>
            </tr>
        );
    }
    else
    {
        PageLocation = (
            <tr height="60">
                <td width="40" align="left">
                    <span width="20" align="left">
                        <img
                            alt="Home logo"
                            className="HomeLogo pointer"
                            src={HomeLogo}
                            onClick={() => navigate("/")}
                        />
                    </span>
                    <span width="20" className="blue" align="center">
                        {" "} / {" "}
                    </span>
                    <a
                        href="../users"
                        className="underline pointer bold"
                        width="40"
                        align="left"
                        textAlign="button"
                    >
                        {Translate("Users")}
                    </a>
                    <span width="20" className="blue" align="center">
                        {" "} / {" "}
                    </span>
                    <span width="50" align="left" className="bold">
                        {mUser ? mUser.Name : ""}
                    </span>
                    <span width="20" className="blue" align="center">
                        {" "} / {" "}
                    </span>
                    <span className="bold">{Translate("Edit")}</span>
                </td>
            </tr>
        );
    }

    return(
        
        <span>

            <Header onLanguageChanged={() => languageChanged()}/>
            
            <MainMenu MainMenuNumber={mTenantGuid ? 1 : 2} />

                <table width="1200" cellPadding={0} cellSpacing={0} align="center">
                <tbody>

                    <tr className="pagetop3">
                        <td height="75" valign="bottom">
                            <table width="100%" cellPadding={0} cellSpacing={0} className="down10px">
                                <tbody>
                                    {PageLocation}
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
                </table>

                <table width="1200" cellPadding={0} cellSpacing={0} align="center" >
                    <tbody>                

                        <tr className="pagetop4">
                            <td colSpan={4} height="75" valign="left" className="activetenants width30">
                                {Translate("User settings")}
                            </td>
                        </tr>

                        <tr className="pagetop4">
                            <td colSpan={4} className="horizontalLine width30" >
                                <BlueBar/>
                            </td>
                        </tr>

                        <tr height="50"/>                
                    </tbody>
            </table>

                <table className="usermainsettingtable" width="1200" cellPadding={0} cellSpacing={0} align="center">
                <tbody>

                    <tr height="20" ></tr>
                   
                    <tr>
                        <td width="40"></td>
                        <td className="bold fontsizelarge">{Translate("Main settings")}</td>
                        <td></td>
                    </tr>
                    
                    <tr height="20"/>
                    
                    <tr>
                        <td width="40"></td>
                        <td className="bold fontsizesmall">{Translate("Name")}</td>
                    </tr>
                   
                   <tr height="10"/>

                    <tr height="40">
                        <td width="40"></td>
                        <td width="1000"><input value={mUser ? mUser.Name: ''} onChange={e=>SetName(e.target.value)} className="inputtd"></input></td>
                        <td></td>
                    </tr>

                    <tr height="20"/>
                
                    <tr>
                        <td width="40"></td>
                        <td className="bold fontsizesmall">{Translate("Email")}</td>
                    </tr>
                   
                    <tr height="10"/>

                    <tr height="40">
                        <td width="40"></td>
                        <td width="1000"><input value={mUser ? mUser.Email : '' } onChange={e=>SetEmail(e.target.value)} className="inputtd"></input></td>
                        <td></td>
                    </tr>

                    <tr height="20"/>


                    <tr height="20"></tr>

                    <tr>
                        <td width="40"></td>
                        <td className="bold fontsizesmall">{Translate("User API settings")}</td>
                    </tr>
                   
                    <tr height="10"/>

                    <tr height="80">
                        <td width="40"></td>
                        <td><textarea value={mUser ? mUser.ApiSettings : ''} onChange={e=>SetUserApiSetting(e.target.value)} className="textareaedituser"></textarea></td>
                        <td></td>
                    </tr>

                   <tr height="20"/>
                
                    <tr>
                        <td width="40"></td>
                        <td className="bold fontsizesmall"><input checked={mUser ? mUser.IsRecognitionAdmin : false} onChange={e=>SetIsRecognitionAdmin(e.target.checked)} type="checkbox"/>
                            <span> </span> 
                            {Translate("CRM Integration Admin; required to configure the CRM integration settings of the user’s organization.")}
                        </td>
                    </tr>

                    <tr height="20"/>
                
                    <tr>
                        <td width="40"></td>
                        <td className="bold fontsizesmall"><input checked={ mUser ? (mUser.IsTenantAdmin === true) : false} onChange={e=>SetIsTenantAdmin(e.target.checked)} type="checkbox"/> 
                        <span> </span>
                        {Translate("User Account Admin; required to configure the organization’s other user accounts.")}
                        </td>
                    </tr>
                
                <tr height="20"/>

                <tr>
                    <td width="40"></td>
                    {mUpdateSuccessfully ? <td className="bold green">{mUpdateResult}</td> : <td className="bold red">{mUpdateResult}</td>}
                </tr>

                <tr height="15"></tr>
                
                <tr>
                    <td width="40"></td>
                    <td className="bold fontsizesmall">
                        <button className="blackbackground white pointer borderradios buylicencebutton btn btn-dark" onClick={()=> handleSaveUserSettings()}>{Translate("Save user settings")}</button> 
                    </td>
                </tr>
                   
                <tr height="20"/>       

                </tbody>
            </table>
            
            {/*Free space*/}
            <table>
                <tbody>
                    <tr height="60"/>
                </tbody>
            </table>

            <table className="usermainsettingtable" width="1200" cellPadding={0} cellSpacing={0} align="center">
                <tbody>

                    <tr height="20" ></tr>
                   
                    <tr>
                       <td width="40"></td>
                       <td className="bold fontsizelarge">{Translate("License settings")}</td>
                       <td></td>
                    </tr>

                    <tr height="20" ></tr>

                <tr>
                    <td width="40"></td>
                    <td className="bold">{Translate("Choose a new option from the list to change the license")}</td>
                </tr>

                <tr height="20"/>
                
                <tr height="40">
                    <td width="40"></td>
                    <td width="1000">
                        <select
                            className="inputtd"
                            onChange={e => {
                                SetLicenceGuid(e.target.value);
                                SetRepaint(!mRepaint);
                            }}
                        >
                            <option key="current" value={mUser ? (mUser.LicenceGuid ? mUser.LicenceGuid : "") : ""}>
                                {mUser?.LicenceGuid ? mUser.LicenceName : "Please choose a license"}
                            </option>
                            {mLicenceGuid && <option key="none" value="None">{Translate("None")}</option>}
                            {mLicenceList.map((licence) => (
                                <option key={licence.LicenceGuid} value={licence.LicenceGuid}>
                                    {licence.Name}
                                </option>
                            ))}
                        </select>
                    </td>
                </tr>
                
                <tr height="20"/>
                
                {((mUser?.LicenceGuid !== "") && (mLicenceGuid && mLicenceGuid !== null) && (mLicenceGuid !== mUser.LicenceGuid)) &&
                    (sessionStorage.getItem("IsSuperTenant") === "1" && sessionStorage.getItem("ManageLicenses") === "1") && 
                    <tr>
                        <td width="40"></td>
                        <table>
                            <tbody>
                                <td><input onChange={e=>ChangeExpireCurrentLicenseVariable(e.target.checked)} type="checkbox"/></td>
                                <td>{Translate("Keep the current license.")}</td>
                            </tbody>
                        </table>
                    </tr>
                }

                {((mUser?.LicenceGuid !== "") && (mLicenceGuid && mLicenceGuid !== null) && (mLicenceGuid !== mUser.LicenceGuid)) && <tr height="10"/>}

                <tr>
                    <td width="40"/>
                    <button disabled={ mUser?.LicenceGuid ? ((mLicenceGuid !== mUser.LicenceGuid) ? false : true) : false } className="blackbackground white pointer borderradios buylicencebutton btn btn-dark" onClick={()=> AssignNewLicense()}>{Translate("Change license")}</button> 
                </tr>
                   
                <tr height="20"/>
            </tbody>
            </table>
            
            <table>
                <tbody>
                    <tr height="80"/>
                </tbody>
            </table>



            <table className="usermainsettingtable" width="1200" cellPadding={0} cellSpacing={0} align="center">
            <tbody>

                <tr height="20" ></tr>
                   
                <tr>
                    <td width="40"></td>
                    <td className="bold fontsizelarge">{Translate("Change password")}</td>
                    <td></td>
                </tr>
                
                <tr height="20"/>
                
                <tr>
                    <td width="40"></td>
                    <td>
                        {Translate("New password must comply with the following")}
                    </td>
                </tr>
                
                <tr height="8"/>
                   
                <tr>
                    <td width="40"></td>
                    <td>
                        <table>
                            <tbody>
                                <tr>
                                    <td width="8"/>
                                    <td className="dot"></td>
                                    <td className="fontsizesmall paddingleft">{Translate("Must contain between 8 and 50 characters")}</td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>

                <tr height="8"/>
                
                <tr>
                    <td width="40"></td>
                    <td>
                        <table>
                            <tbody>
                                <tr>
                                    <td width="8"/>
                                    <td className="dot"></td>
                                    <td className="fontsizesmall paddingleft">
                                        {Translate("Must contain at least 1 letter")}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>

                <tr height="8"/>

                <tr>
                    <td width="40"></td>
                    <td>
                        <table>
                            <tbody>
                                <tr>
                                    <td width="8"/>
                                    <td className="dot"></td>
                                    <td className="fontsizesmall paddingleft">
                                        {Translate("Must contain at least 1 digit")}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>

                <tr height="8"/>
                   
                <tr>
                    <td width="40"></td>
                    <td>
                        <table>
                            <tbody>
                                <tr>
                                    <td width="8"/>
                                    <td className="dot"></td>
                                    <td className="fontsizesmall paddingleft">
                                        {Translate("Must contain at least 1 special character [~`!@#$%^&*()_+=|[]:;']")}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>

                <tr height="20"></tr>

                <tr>
                    <td width="40"></td>
                    <td className="bold fontsizesmall">{Translate("Password")} <span className="red"> *</span></td>
                </tr>
                   
                <tr height="10"/>

                <tr height="40">
                    <td width="40"></td>
                    <td><input type={mPasswordVisible ? "text" : "password"}  onChange={e=>SetUserPassword(e.target.value)} className="inputtd"></input>
                        <span className="passwordtoggleicon" onClick={() => SetPasswordVisible(!mPasswordVisible)}>{mPasswordVisible ? '👁️' : '👁️‍🗨️'} </span>
                    </td>
                    <td></td>
                </tr>

                <tr height="20"/>

                <tr>
                    <td width="40"></td>
                    <td width="100"><PasswordStrengthBar password={mUserPassword} /></td>
                </tr> 

                <tr height="20"/>

                <tr>
                    <td width="40"></td>
                    <td className="bold fontsizesmall">{Translate("Confirm new password")} <span className="red"> * </span></td>
                </tr>
                   
                <tr height="10"/>

                <tr height="40">
                    <td width="40"></td>
                    <td><input type="password" onChange={e=>SetConfirmPassword(e.target.value)} className="inputtd"></input></td>
                    <td></td>
                </tr>

                <tr height="20"></tr>

                <tr>
                    <td width="40"/>
                        {mChangePasswordSuccessfully ? <td className="green bold">{mChangePasswordResult}</td> : <td className="red bold">{mChangePasswordResult}</td> }
                </tr>

                <tr height="15"></tr>
                
                <tr>
                    <td width="40"></td>
                    <td className="bold fontsizesmall">
                        <button className="saveusersettingsbutton bold" onClick={()=>handleChangePassword()}>{Translate("Change password")}</button> 
                    </td>
                </tr>
                
                <tr height="20"/>       
                </tbody>
            </table>

            <table>
                <tbody>
                    <tr height="40"></tr>
                </tbody>
            </table>

            {/*Delet User Table*/}
            <table className="usermainsettingtable" width="1200" cellPadding={0} cellSpacing={0} align="center">
                <tbody>

                    <tr height="20" ></tr>
                    
                    <tr>
                        <td width="40"></td>
                        <td>
                            <table>
                                <tbody>
                                    <tr>
                                        <td><img alt="Close logo" width="20" src={CloseLogo}/></td>
                                        <td className="bold fontsizelarge paddingleft "><span> </span>{Translate("Delete this user")}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>

                    <tr height="20" />
                        
                    <tr>
                        <td width="40"></td>
                        <td className="bold fontsizesmall">
                            <button 
                                className="blackbackground white pointer borderradios buylicencebutton btn btn-dark" 
                                onClick={() => {handleDeleteUser()}}
                            >
                                {Translate("Delete user")}
                            </button>
                        </td>
                    </tr>
    
                    <tr height="40"/>
                </tbody>
            </table>

            {/*FreeSpace*/}
            <table>
                <tbody>
                    <tr height="80"></tr>
                </tbody>
            </table>

            {/*footerTable*/}
            <table>
                <tbody>
                    <tr height="60"></tr>
                </tbody>
            </table>

            <Footer/>

            {/*Animation part*/}
            <Modal animation={false} style={{opacity:1}} show={mExpireLicence !== ""} onHide={() => SetExpireLicence("")} centered={true}>
                <Modal.Header closeButton={true}>
                    <Modal.Title align="center"><span align="center">{("Are you sure for expiring this license?")}</span></Modal.Title>
                </Modal.Header>
                <Modal.Footer align="center">
                    <Button variant="dark" onClick={() => ExpireLicence()}>OK</Button>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                    <Button variant="dark" onClick={() =>SetExpireLicence("")}>Cancel</Button>
                </Modal.Footer>
            </Modal>

            {/* Animation part for buying lincese */}
            <Modal animation={false} style={{ opacity: 1 }} show={mAssignNewLicenceError !== ""} onHide={() => SetAssignNewLicenceError("")} centered={true}>
                <Modal.Header closeButton={true} className="d-flex flex-column align-items-center">
                    <Modal.Title align="center">
                        <span align="center">
                            {mAssignNewLicenceError === "Not enough licenses"
                                ? Translate("The selected license is not available. Do you want to add this license to the tenant?")
                                : ""}
                        </span>
                    </Modal.Title>
                    {mAssignNewLicenceError === "Not enough licenses" && (
                        <small style={{ fontSize: "12px", textAlign: "center", marginTop: "10px" }}>
                            {Translate("By clicking “Buy license” you agree to our")}{" "}
                            <a
                                href="https://downloadcloudcti.blob.core.windows.net/files/Website/Terms%20of%20Delivery%20CloudCTI-2015-1%20EN.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {Translate("Terms of Delivery")}
                            </a>
                        </small>
                    )}
                </Modal.Header>
                <Modal.Footer align="center">
                    <Button variant="dark" onClick={() => { BuyLicenseButtonHandler(); }}>{Translate("Buy licenses")}</Button>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <Button variant="dark" onClick={() => SetAssignNewLicenceError("")}>{Translate("Cancel")}</Button>
                </Modal.Footer>
            </Modal>

            {/*Animation for showing the error of managing licenses.*/}
            <Modal animation={false} style={{opacity:1}} show={mShowPopUpErrorBuyingLicenses !== ""} onHide={() => SetShowPopUpErrorBuyingLicenses("")} centered={true}>
                <Modal.Header closeButton={true}>
                    <Modal.Title align="center"><span align="center">{mShowPopUpErrorBuyingLicenses}</span></Modal.Title>
                </Modal.Header>
                <Modal.Footer align="center">
                    <Button variant="dark" onClick={() => {SetShowPopUpErrorBuyingLicenses("")}}>{Translate("Ok")}</Button>
                </Modal.Footer>
            </Modal>

            <Modal
                animation={false}
                style={{ opacity: 1 }}
                show={mGeneralPopup !== ""}
                onHide={() => SetGeneralPopUp("")}
                centered
                >
                <Modal.Header closeButton>
                    <Modal.Title className="w-100 text-center">
                    </Modal.Title>
                </Modal.Header>

                {/* ✅ Move the actual message here */}
                <Modal.Body>
                    <div className="text-center">
                    {mGeneralPopup}
                    </div>
                </Modal.Body>

                <Modal.Footer className="justify-content-center">
                    <Button variant="dark" onClick={() => SetGeneralPopUp("")}>
                    {Translate("Ok")}
                    </Button>
                </Modal.Footer>
            </Modal>

        </span>
    )
    
}

export default EditUser